module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('section', {
    staticClass: "wrapper departure section"
  }, [_h('div', {
    staticClass: "inner"
  }, [_h('h1', ["3. Themes"]), " ", _h('div', {
    staticClass: "row uniform"
  }, [_h('div', {
    staticClass: "6u"
  }, [_h('span', {
    staticClass: "image fit"
  }, [_h('img', {
    attrs: {
      "src": require("images/beaches.jpg"),
      "alt": "airplane"
    }
  })])]), " ", _h('div', {
    staticClass: "6u"
  }, [_h('span', {
    staticClass: "image fit"
  }, [_h('img', {
    attrs: {
      "src": require("images/mountains.jpg"),
      "alt": "airplane"
    }
  })])]), " ", _h('div', {
    staticClass: "6u"
  }, [_h('span', {
    staticClass: "image fit"
  }, [_h('img', {
    attrs: {
      "src": require("images/nature.jpg"),
      "alt": "airplane"
    }
  })])]), " ", _h('div', {
    staticClass: "6u"
  }, [_h('span', {
    staticClass: "image fit"
  }, [_h('img', {
    attrs: {
      "src": require("images/shopping.jpg"),
      "alt": "airplane"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1422119c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Themes.vue
// module id = 40
// module chunks = 1